/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
    this.shimmerContainer = this.querySelector(".skeleton-container");
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;

      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '0px 0px 300px 0px' }).observe(this);
    }
  }
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    if (this.shimmerContainer) {
      this.shimmerContainer.classList.remove("hidden");
    }
    this.fetchSections();
  }
  handleMouseover() {
    this.removeTrigger();
    this.fetchSections();
  }
  handleClick() {
    this.removeTrigger();
    this.fetchSections();
  }
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;
    if (LazySection.abortController) {
      LazySection.abortController.abort();
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.innerHTML = sectionContent.innerHTML;
            // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });
          }
        }

        if (this.shimmerContainer) {
          this.shimmerContainer.classList.add("hidden");
        }

        if (sectionsToFetchBatch.length < 5)
          LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}

customElements.define('lazy-section', LazySection);
const triggerLazySectionsOnce = () => {
  document.querySelectorAll('lazy-section').forEach(el => el.fetchSections?.());
  ['scroll', 'mousemove', 'touchstart'].forEach(event =>
    window.removeEventListener(event, triggerLazySectionsOnce)
  );
};

['scroll', 'mousemove', 'touchstart'].forEach(event =>
  window.addEventListener(event, triggerLazySectionsOnce, { once: true })
);




  /* Helper: Keep line item DOM key attributes synchronized with Shopify cart API keys */
  function syncItemKeyAttributes(itemEl, newKey) {
    if (!itemEl || !newKey) return;
    itemEl.dataset.item = newKey;
    itemEl.setAttribute('data-item', newKey);

    var removeBtn = itemEl.querySelector('[data-item-remove]');
    if (removeBtn) {
      removeBtn.dataset.id = newKey;
      removeBtn.setAttribute('data-id', newKey);
    }

    var qtyInput = itemEl.querySelector('input[name="updates[]"]');
    if (qtyInput) {
      qtyInput.id = 'updates_' + newKey;
      qtyInput.dataset.id = newKey;
      qtyInput.setAttribute('data-id', newKey);
    }

    var sizeSelect = itemEl.querySelector('[data-cart-size-select]');
    if (sizeSelect) {
      sizeSelect.dataset.lineKey = newKey;
    }
  }

  /* Helper: Re-index 1-based data-item-index attributes across cart drawer items */
  function reindexCartItemIndices() {
    var items = document.querySelectorAll('cart-drawer [data-item], [data-drawer="cart"] [data-item], cart-items [data-item]');
    items.forEach(function (el, index) {
      var lineIdx = String(index + 1);
      el.setAttribute('data-item-index', lineIdx);
      el.dataset.itemIndex = lineIdx;
    });
  }

  /* Cart Drawer: Fast In-Place Size Selector variant switcher */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-cart-size-select]');
    if (!select) return;

    var newVariantId = parseInt(select.value, 10);
    var currentVariantId = parseInt(select.dataset.currentVariant, 10);
    var lineKey = select.dataset.lineKey;
    var quantity = parseInt(select.dataset.quantity, 10) || 1;

    if (!newVariantId || newVariantId === currentVariantId) return;

    var chip = select.closest('[data-cart-size-selector]');
    var lineItem = select.closest('[data-item]');
    var label = chip ? chip.querySelector('[data-size-label]') : null;

    var selectedOption = select.options[select.selectedIndex];
    var newSizeText = selectedOption ? selectedOption.text.split('-')[0].trim() : '';

    // Show circular loader spinner during update (size text updates only after completion)
    if (chip) {
      chip.classList.add('is-loading');
    }
    var priceElSize = lineItem ? (lineItem.querySelector('.cart__item__header .cart__item__price') || lineItem.querySelector('.cart__item__price')) : null;
    if (priceElSize) {
      priceElSize.classList.add('is-loading-price');
    }
    var priceHolderSize = document.querySelector('[data-cart-price-holder]');
    if (priceHolderSize) {
      priceHolderSize.classList.add('is-loading');
    }
    select.disabled = true;

    var properties = {};
    if (select.dataset.properties) {
      try {
        var parsed = JSON.parse(select.dataset.properties);
        if (Array.isArray(parsed)) {
          parsed.forEach(function (prop) {
            if (Array.isArray(prop) && prop.length >= 2) {
              properties[prop[0]] = prop[1];
            } else if (prop && prop.name) {
              properties[prop.name] = prop.value;
            }
          });
        } else if (typeof parsed === 'object' && parsed !== null) {
          properties = parsed;
        }
      } catch (err) {}
    }

    var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
    var changeUrl = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || '/cart/change.js';

    // Step 1: Add new variant
    fetch(addUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: newVariantId,
        quantity: quantity,
        properties: properties
      })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function () {
        // Step 2: Remove old variant and get updated cart + sections in one request
        return fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: lineKey,
            quantity: 0,
            sections: 'api-cart-items'
          })
        });
      })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) { throw err; });
        }
        return res.json();
      })
      .then(function (cartData) {
        var cartItemsInst = document.querySelector('cart-items');
        var domItemsCount = document.querySelectorAll('cart-drawer [data-item], [data-drawer="cart"] [data-item], cart-items [data-item]').length;

        // If items merged (size already existed in cart, so item count changed), rebuild drawer HTML
        if (cartData && cartData.items && cartData.sections && cartData.sections['api-cart-items'] && cartData.items.length !== domItemsCount) {
          var doc = new DOMParser().parseFromString(cartData.sections['api-cart-items'], 'text/html');
          var apiContent = doc.querySelector('[data-api-content]');
          if (apiContent && cartItemsInst && typeof cartItemsInst.build === 'function') {
            cartItemsInst.build(apiContent);
            return;
          }
        }

        // Find the new variant in the updated cart items
        var updatedItem = null;
        if (cartData && cartData.items) {
          updatedItem = cartData.items.find(function (it) {
            return it.variant_id === newVariantId;
          });
        }

        if (updatedItem && lineItem) {
          // Display the new size only after the update is completed
          if (label && newSizeText) {
            label.textContent = newSizeText;
          }
          if (chip) {
            chip.setAttribute('title', newSizeText);
          }

          // In-place update: update lineKey references so remove and quantity still work
          var newKey = updatedItem.key;
          syncItemKeyAttributes(lineItem, newKey);
          select.dataset.currentVariant = String(newVariantId);
          reindexCartItemIndices();

          // Update item price if variant has a different price
          var priceEl = lineItem.querySelector('.cart__item__header .cart__item__price') || lineItem.querySelector('.cart__item__price');
          if (priceEl && updatedItem.final_line_price !== undefined) {
            if (window.theme && typeof window.theme.formatMoney === 'function') {
              priceEl.innerHTML = window.theme.formatMoney(updatedItem.final_line_price, window.theme.moneyFormat);
            }
          }

          // Update subtotal
          var subtotalEl = document.querySelector('[data-cart-total]');
          if (subtotalEl && cartData.total_price !== undefined) {
            if (window.theme && typeof window.theme.formatMoney === 'function') {
              subtotalEl.innerHTML = window.theme.formatMoney(cartData.total_price, window.theme.moneyWithCurrencyFormat || window.theme.moneyFormat);
            }
          }

          // Update free shipping bar and cart count in-place
          if (cartItemsInst) {
            if (typeof cartItemsInst.freeShippingMessageHandle === 'function' && cartData.total_price !== undefined) {
              cartItemsInst.subtotal = cartData.total_price;
              cartItemsInst.freeShippingMessageHandle(cartData.total_price);
            }
            if (typeof cartItemsInst.updateProgress === 'function') {
              cartItemsInst.updateProgress();
            }
          }
          document.dispatchEvent(new CustomEvent('theme:cart:change', {
            bubbles: true,
            detail: { cartCount: cartData.item_count }
          }));
        } else if (cartData && cartData.sections && cartData.sections['api-cart-items']) {
          // Fallback: refresh drawer items from section
          var doc2 = new DOMParser().parseFromString(cartData.sections['api-cart-items'], 'text/html');
          var apiContent2 = doc2.querySelector('[data-api-content]');
          if (apiContent2 && cartItemsInst && typeof cartItemsInst.build === 'function') {
            cartItemsInst.build(apiContent2);
          }
        }
      })
      .catch(function (err) {
        console.error('Failed to change size:', err);
        select.value = currentVariantId;
        var cartItemsInst = document.querySelector('cart-items');
        if (cartItemsInst && typeof cartItemsInst.getCart === 'function') {
          cartItemsInst.getCart();
        } else {
          alert(err.description || err.message || 'Unable to update size. Please try again.');
        }
      })
      .finally(function () {
        if (chip) {
          chip.classList.remove('is-loading');
        }
        if (priceElSize) {
          priceElSize.classList.remove('is-loading-price');
        }
        if (priceHolderSize) {
          priceHolderSize.classList.remove('is-loading');
        }
        select.disabled = false;
      });
  });

  /* Cart Drawer: Fast In-Place Quantity Update & Item Removal (Zero full-drawer flash/reload) */
  (function () {
    var quantityDebounceTimers = {};
    var activeAbortControllers = {};

    function updateCartDrawerUI(cartData, itemKey, newQty, itemEl) {
      var cartItems = document.querySelector('cart-items');
      var priceEl = itemEl ? (itemEl.querySelector('.cart__item__header .cart__item__price') || itemEl.querySelector('.cart__item__price')) : null;
      var qtyInput = itemEl ? itemEl.querySelector('input[name="updates[]"]') : null;
      var sizeSelect = itemEl ? itemEl.querySelector('[data-cart-size-select]') : null;

      // Remove loading state from item price and subtotal holder
      document.querySelectorAll('.cart__item__price.is-loading-price').forEach(function (el) {
        el.classList.remove('is-loading-price');
      });
      var priceHolder = document.querySelector('[data-cart-price-holder]');
      if (priceHolder) priceHolder.classList.remove('is-loading');

      if (priceEl) priceEl.style.opacity = '';

      // Find this item in returned cart
      var updatedItem = null;
      if (cartData && cartData.items) {
        updatedItem = cartData.items.find(function (it) {
          return it.key === itemKey || String(it.id) === String(itemKey) || String(it.variant_id) === String(itemKey) || (itemKey && itemKey.indexOf(String(it.variant_id)) === 0);
        });
      }

      // Sync updated item key across DOM dataset attributes to prevent stale key errors
      if (updatedItem && updatedItem.key && itemEl) {
        syncItemKeyAttributes(itemEl, updatedItem.key);
      }
      reindexCartItemIndices();

      // 0. Toggle 'is-empty' class on cart-drawer container if item count is 0
      var cartDrawerContainer = document.querySelector('cart-drawer, [data-drawer="cart"]');
      if (cartDrawerContainer && cartData && cartData.item_count !== undefined) {
        cartDrawerContainer.classList.toggle('is-empty', cartData.item_count === 0);
      }

      // 1. Update line item price in place
      if (priceEl && updatedItem && updatedItem.final_line_price !== undefined) {
        if (window.theme && typeof window.theme.formatMoney === 'function') {
          var moneyFmt = window.theme.moneyFormat || (typeof theme !== 'undefined' && theme.moneyFormat);
          priceEl.innerHTML = window.theme.formatMoney(updatedItem.final_line_price, moneyFmt);
        }
      }

      // 2. Sync quantity input value & inventory limits
      if (qtyInput && updatedItem) {
        qtyInput.value = updatedItem.quantity;
        qtyInput.setAttribute('value', updatedItem.quantity);

        if (newQty > updatedItem.quantity) {
          qtyInput.setAttribute('max', updatedItem.quantity);
          qtyInput.dataset.max = String(updatedItem.quantity);
          showCartMaxInventoryMessage(updatedItem.title || (itemEl && itemEl.dataset.itemTitle));
        }

        var qtyComponent = itemEl ? itemEl.querySelector('quantity-input') : null;
        if (qtyComponent && typeof qtyComponent.validateQtyRules === 'function') {
          qtyComponent.validateQtyRules();
        }
      }

      // 3. Update size select data-quantity attribute
      if (sizeSelect && updatedItem) {
        sizeSelect.dataset.quantity = String(updatedItem.quantity);
      }

      // 4. Update cart subtotal & discounts from api-cart-price section
      if (cartData && cartData.sections && cartData.sections['api-cart-items']) {
        try {
          var doc = new DOMParser().parseFromString(cartData.sections['api-cart-items'], 'text/html');
          var newPriceHolder = doc.querySelector('[data-api-cart-price]');
          var currentPriceHolder = document.querySelector('[data-cart-price-holder]');
          if (currentPriceHolder && newPriceHolder) {
            currentPriceHolder.innerHTML = newPriceHolder.innerHTML;
          }
        } catch (e) {}
      }

      var moneyFmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : (typeof theme !== 'undefined' && theme.moneyFormat ? theme.moneyFormat : null);
      var moneyWithCurrencyFmt = window.theme && window.theme.moneyWithCurrencyFormat ? window.theme.moneyWithCurrencyFormat : moneyFmt;

      var subtotalEl = document.querySelector('[data-cart-total]');
      if (subtotalEl && cartData && cartData.total_price !== undefined) {
        if (cartItems) cartItems.subtotal = cartData.total_price;
        if (window.theme && typeof window.theme.formatMoney === 'function') {
          subtotalEl.innerHTML = (cartData.total_price === 0)
            ? (window.theme.strings && window.theme.strings.free ? window.theme.strings.free : '$0.00')
            : window.theme.formatMoney(cartData.total_price, moneyWithCurrencyFmt || moneyFmt);
        }
      }

      // Update shipping charge & final estimated total dynamically
      var shippingRow = document.querySelector('[data-shipping-charge-row]');
      var shippingPriceEl = document.querySelector('[data-cart-shipping-price]');
      var finalTotalEls = document.querySelectorAll('[data-cart-final-total], .cart__total-main-price');

      if (shippingRow && cartData && cartData.total_price !== undefined) {
        var freeShippingLimit = parseFloat(shippingRow.dataset.freeShippingLimit) || 9999;
        var shippingChargeCents = parseFloat(shippingRow.dataset.shippingChargeCents) || 29900;
        var subtotalCents = cartData.total_price;
        var subtotalAmount = subtotalCents / 100;
        var isFreeShipping = freeShippingLimit > 0 && subtotalAmount >= freeShippingLimit;
        var finalShippingCents = isFreeShipping ? 0 : shippingChargeCents;
        var finalTotalCents = subtotalCents + finalShippingCents;

        if (shippingPriceEl) {
          if (isFreeShipping) {
            shippingPriceEl.innerHTML = '<span class="shipping-fee-free" style="color: #2e7d32; font-weight: 600;">FREE</span>';
          } else if (window.theme && typeof window.theme.formatMoney === 'function') {
            shippingPriceEl.innerHTML = window.theme.formatMoney(shippingChargeCents, moneyWithCurrencyFmt || moneyFmt);
          }
        }

        if (finalTotalEls.length && window.theme && typeof window.theme.formatMoney === 'function') {
          var formattedFinalTotal = window.theme.formatMoney(finalTotalCents, moneyWithCurrencyFmt || moneyFmt);
          finalTotalEls.forEach(function (el) {
            el.innerHTML = formattedFinalTotal;
            el.dataset.cartFinalTotal = finalTotalCents;
          });
        }
      }

      // 5. Update free shipping bar
      if (cartItems && cartData) {
        if (typeof cartItems.freeShippingMessageHandle === 'function' && cartData.total_price !== undefined) {
          cartItems.freeShippingMessageHandle(cartData.total_price);
        }
        if (typeof cartItems.updateProgress === 'function') {
          cartItems.updateProgress();
        }
        cartItems.cartCount = cartData.item_count;
        if (cartData.items) cartItems.totalItems = cartData.items.length;
      }

      // 6. Update cart counts throughout page & drawer header
      if (cartData && cartData.item_count !== undefined) {
        document.querySelectorAll('[data-cart-count]').forEach(function (cnt) {
          cnt.setAttribute('data-cart-count', cartData.item_count);
          cnt.innerText = cartData.item_count;
        });

        // 7. Dispatch theme:cart:change to trigger header "YOUR BAG • N ITEMS" update
        document.dispatchEvent(new CustomEvent('theme:cart:change', {
          bubbles: true,
          detail: { cartCount: cartData.item_count, source: 'in-place-quantity' }
        }));
      }
    }

    function handleInPlaceItemRemoval(itemEl, itemKey) {
      if (!itemEl) return;

      if (itemKey && quantityDebounceTimers[itemKey]) {
        clearTimeout(quantityDebounceTimers[itemKey]);
        delete quantityDebounceTimers[itemKey];
      }
      if (itemKey && activeAbortControllers[itemKey]) {
        activeAbortControllers[itemKey].abort();
        delete activeAbortControllers[itemKey];
      }

      var priceHolder = document.querySelector('[data-cart-price-holder]');
      if (priceHolder) priceHolder.classList.add('is-loading');

      // Visual loader state on removing item while network request is pending
      itemEl.style.pointerEvents = 'none';
      itemEl.classList.add('is-removing');

      var priceEl = itemEl.querySelector('.cart__item__header .cart__item__price') || itemEl.querySelector('.cart__item__price');
      if (priceEl) priceEl.classList.add('is-loading-price');

      var removeBtn = itemEl.querySelector('[data-item-remove]');
      if (removeBtn) {
        removeBtn.style.opacity = '0.5';
        removeBtn.style.pointerEvents = 'none';
      }

      var changeUrl = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || '/cart/change.js';

      fetch(changeUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
          sections: 'api-cart-items'
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cartData) {
          var cartItems = document.querySelector('cart-items');

          if (cartData.errors || cartData.status === 422) {
            if (cartItems && typeof cartItems.getCart === 'function') {
              cartItems.getCart();
            }
            return;
          }

          // Synchronously update all quantities, subtotal, shipping bar, totals & count badges ALL AT ONCE
          updateCartDrawerUI(cartData, itemKey, 0, null);

          // If cart is now completely empty, transition to empty view
          if (cartData && cartData.item_count === 0) {
            var cartDrawerContainer = document.querySelector('cart-drawer, [data-drawer="cart"]');
            if (cartDrawerContainer) {
              cartDrawerContainer.classList.add('is-empty');
            }
            if (cartItems && typeof cartItems.getCart === 'function') {
              cartItems.getCart();
            }
            return;
          }

          // Lock current height for smooth collapse transition without visual cropping
          var currentHeight = itemEl.offsetHeight;
          itemEl.style.maxHeight = currentHeight + 'px';
          itemEl.style.overflow = 'hidden';
          itemEl.style.transition = 'opacity 0.18s ease-out, max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1), margin 0.25s ease, padding 0.25s ease';

          // Force reflow
          itemEl.offsetHeight;

          // Target collapse styles
          itemEl.style.opacity = '0';
          itemEl.style.maxHeight = '0px';
          itemEl.style.paddingTop = '0px';
          itemEl.style.paddingBottom = '0px';
          itemEl.style.marginTop = '0px';
          itemEl.style.marginBottom = '0px';

          setTimeout(function () {
            if (itemEl && itemEl.parentNode) {
              itemEl.parentNode.removeChild(itemEl);
            }
            reindexCartItemIndices();
          }, 260);
        })
        .catch(function (err) {
          console.error('Error removing cart item:', err);
          var cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.getCart === 'function') {
            cartItems.getCart();
          } else {
            itemEl.classList.remove('is-removing');
            itemEl.style.pointerEvents = '';
            itemEl.style.opacity = '';
            if (priceEl) priceEl.classList.remove('is-loading-price');
            if (removeBtn) {
              removeBtn.style.opacity = '';
              removeBtn.style.pointerEvents = '';
            }
            if (priceHolder) priceHolder.classList.remove('is-loading');
          }
        });
    }

    function handleInPlaceQuantityUpdate(itemEl, itemKey, newQty) {
      if (!itemEl || !itemKey) return;

      var priceEl = itemEl.querySelector('.cart__item__header .cart__item__price') || itemEl.querySelector('.cart__item__price');
      var qtyInput = itemEl.querySelector('input[name="updates[]"]');

      // Visual feedback: show loader on price element and subtotal price holder immediately
      if (priceEl) {
        priceEl.classList.add('is-loading-price');
      }
      var priceHolder = document.querySelector('[data-cart-price-holder]');
      if (priceHolder) {
        priceHolder.classList.add('is-loading');
      }

      // Clear any pending debounce timer for this item
      if (quantityDebounceTimers[itemKey]) {
        clearTimeout(quantityDebounceTimers[itemKey]);
      }

      quantityDebounceTimers[itemKey] = setTimeout(function () {
        delete quantityDebounceTimers[itemKey];

        // Abort previous in-flight request for this item if still running
        if (activeAbortControllers[itemKey]) {
          activeAbortControllers[itemKey].abort();
        }
        var controller = new AbortController();
        activeAbortControllers[itemKey] = controller;

        var changeUrl = (window.theme && window.theme.routes && window.theme.routes.cart_change_url) || '/cart/change.js';

        // Cart change request with sections: 'api-cart-items' for accurate server price rendering
        fetch(changeUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          signal: controller.signal,
          body: JSON.stringify({
            id: itemKey,
            quantity: newQty,
            sections: 'api-cart-items'
          })
        })
          .then(function (res) {
            return res.json();
          })
          .then(function (cartData) {
            if (activeAbortControllers[itemKey] === controller) {
              delete activeAbortControllers[itemKey];
            }

            if (cartData.errors || cartData.status === 422 || cartData.message) {
              var errorMsg = cartData.errors || cartData.description || cartData.message;
              console.warn('Cart quantity update error:', errorMsg);
              if (priceEl) priceEl.classList.remove('is-loading-price');
              if (priceHolder) priceHolder.classList.remove('is-loading');

              var isInvalidLineItem = typeof errorMsg === 'string' && errorMsg.toLowerCase().indexOf('invalid line item') !== -1;

              if (isInvalidLineItem) {
                var cartItems = document.querySelector('cart-items');
                if (cartItems && typeof cartItems.getCart === 'function') {
                  cartItems.getCart();
                  return;
                }
              }

              var itemTitle = (itemEl && itemEl.dataset.itemTitle) || (itemEl && itemEl.querySelector('.cart__item__title') && itemEl.querySelector('.cart__item__title').textContent) || '';
              showCartMaxInventoryMessage(itemEl, itemTitle, typeof errorMsg === 'string' ? errorMsg : null);

              // Restore input value from server cart & set max boundary
              var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url ? window.theme.routes.cart_url : '/cart') + '.js';
              fetch(cartUrl)
                .then(function (r) { return r.json(); })
                .then(function (c) {
                  var it = c.items && c.items.find(function (x) { return x.key === itemKey || x.id === parseInt(itemKey, 10); });
                  if (it && qtyInput) {
                    qtyInput.value = it.quantity;
                    qtyInput.setAttribute('value', it.quantity);
                    qtyInput.setAttribute('max', it.quantity);
                    qtyInput.dataset.max = String(it.quantity);

                    var qtyComponent = itemEl ? itemEl.querySelector('quantity-input') : null;
                    if (qtyComponent && typeof qtyComponent.validateQtyRules === 'function') {
                      qtyComponent.validateQtyRules();
                    }
                  } else if (!it) {
                    var cartItems = document.querySelector('cart-items');
                    if (cartItems && typeof cartItems.getCart === 'function') {
                      cartItems.getCart();
                    }
                  }
                });
              return;
            }

            updateCartDrawerUI(cartData, itemKey, newQty, itemEl);
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            console.error('Error updating cart quantity:', err);
            if (priceEl) priceEl.classList.remove('is-loading-price');
            if (priceHolder) priceHolder.classList.remove('is-loading');
            var cartItems = document.querySelector('cart-items');
            if (cartItems && typeof cartItems.getCart === 'function') {
              cartItems.getCart();
            }
          });
      }, 200);
    }

    /* Intercept theme:cart:update at document CAPTURE phase */
    /* This stops the event BEFORE it reaches .cart__item, completely preventing theme.js's full-drawer reload! */
    document.addEventListener('theme:cart:update', function (e) {
      var drawer = e.target.closest('cart-drawer, [data-drawer="cart"]');
      if (!drawer) return; // Not inside cart drawer, let theme.js handle it normally

      e.stopImmediatePropagation();

      var itemEl = e.target.closest('[data-item]');
      if (!itemEl) return;

      var itemKey = (e.detail && e.detail.id) || itemEl.getAttribute('data-item');
      var newQty = e.detail && e.detail.quantity !== undefined ? parseInt(e.detail.quantity, 10) : 1;

      if (newQty === 0) {
        handleInPlaceItemRemoval(itemEl, itemKey);
      } else {
        handleInPlaceQuantityUpdate(itemEl, itemKey, newQty);
      }
    }, true); // TRUE = capture phase!

    /* Intercept [data-item-remove] clicks at document CAPTURE phase */
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('cart-drawer [data-item-remove], [data-drawer] [data-item-remove]');
      if (!removeBtn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var itemEl = removeBtn.closest('[data-item]');
      if (!itemEl) return;
      var itemKey = removeBtn.dataset.id || itemEl.getAttribute('data-item');
      handleInPlaceItemRemoval(itemEl, itemKey);
    }, true); // TRUE = capture phase!

    /* Show max inventory limit error message banner in cart drawer & inline */
    function showCartMaxInventoryMessage(arg1, arg2, arg3) {
      var itemEl = null;
      var titleText = '';
      var customMsg = '';

      if (arg1 && typeof arg1 === 'object' && arg1.nodeType) {
        itemEl = arg1;
        titleText = typeof arg2 === 'string' ? arg2 : '';
        customMsg = typeof arg3 === 'string' ? arg3 : '';
      } else if (typeof arg1 === 'string') {
        if (typeof arg2 === 'string') {
          titleText = arg1;
          customMsg = arg2;
        } else {
          if (arg1.toLowerCase().indexOf('reached') !== -1 || arg1.toLowerCase().indexOf('maximum') !== -1 || arg1.toLowerCase().indexOf('available') !== -1 || arg1.toLowerCase().indexOf('cart') !== -1) {
            customMsg = arg1;
          } else {
            titleText = arg1;
          }
        }
      }

      if (itemEl && !titleText) {
        titleText = itemEl.dataset.itemTitle || (itemEl.querySelector('.cart__item__title') ? itemEl.querySelector('.cart__item__title').textContent.trim() : '');
      }

      var messageText = customMsg;
      if (!messageText || messageText.indexOf('reached the maximum available quantity') !== -1) {
        messageText = 'Maximum quantity reached';
      }

      var errorHolder = document.querySelector('[data-cart-errors]');
      if (errorHolder) {
        var errorMsgEl = errorHolder.querySelector('[data-error-message]');
        if (errorMsgEl) {
          errorMsgEl.innerText = messageText;
        }
        errorHolder.style.display = 'block';
        errorHolder.style.maxHeight = '300px';
        errorHolder.style.opacity = '1';
        errorHolder.style.visibility = 'visible';
        errorHolder.classList.add('is-expanded');
      }

      if (!itemEl && titleText) {
        try {
          var searchTitle = titleText.trim().toLowerCase();
          document.querySelectorAll('[data-item]').forEach(function (el) {
            var elTitle = (el.dataset.itemTitle || (el.querySelector('.cart__item__title') ? el.querySelector('.cart__item__title').textContent : '')).trim().toLowerCase();
            if (elTitle && (elTitle.indexOf(searchTitle) !== -1 || searchTitle.indexOf(elTitle) !== -1)) {
              itemEl = el;
            }
          });
        } catch (e) {}
      }

      if (itemEl) {
        var badge = itemEl.querySelector('.cart__item__max-error-badge');
        if (!badge) {
          badge = document.createElement('div');
          badge.className = 'cart__item__max-error-badge';
          badge.style.cssText = 'background: #ffebee; color: #c62828; border: 1px solid #ef9a9a; border-radius: 4px; padding: 6px 10px; font-size: 11px; font-weight: 600; margin-top: 8px; width: 100%; display: flex; align-items: center; gap: 6px; box-sizing: border-box; line-height: 1.3; transition: opacity 0.3s ease;';
          
          var container = itemEl.querySelector('.cart__item__content') || itemEl;
          container.appendChild(badge);
        }
        badge.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#c62828" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink: 0;"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg> <span>' + messageText + '</span>';
        badge.style.display = 'flex';
        badge.style.opacity = '1';

        if (itemEl._maxBadgeTimer) clearTimeout(itemEl._maxBadgeTimer);
        itemEl._maxBadgeTimer = setTimeout(function () {
          if (badge) {
            badge.style.opacity = '0';
            setTimeout(function() { badge.style.display = 'none'; }, 300);
          }
        }, 4500);
      }

      if (window._cartMaxErrorTimer) clearTimeout(window._cartMaxErrorTimer);
      window._cartMaxErrorTimer = setTimeout(function () {
        if (errorHolder) {
          errorHolder.classList.remove('is-expanded');
          errorHolder.style.maxHeight = '';
          errorHolder.style.opacity = '';
        }
      }, 5000);
    }

    document.addEventListener('theme:cart:max-reached', function (e) {
      var itemEl = e.detail && e.detail.itemEl;
      var itemTitle = e.detail && e.detail.title;
      showCartMaxInventoryMessage(itemEl, itemTitle);
    });

    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-cart-error-close]');
      if (!closeBtn) return;

      var errorHolder = closeBtn.closest('[data-cart-errors]');
      if (errorHolder) {
        errorHolder.classList.remove('is-expanded');
        errorHolder.style.maxHeight = '';
        errorHolder.style.opacity = '';
      }
    });


    /* Defense in depth: Also patch cart-items instance & prototype directly */
    function patchCartItemsInstance(cartItems) {
      if (!cartItems || cartItems._inPlacePatched) return;
      cartItems._inPlacePatched = true;

      cartItems.updateCart = function (t, e) {
        t = t || {};
        var itemEl = (t.id ? (cartItems.cart || cartItems).querySelector('[data-item="' + t.id + '"]') : null) || e;
        var itemKey = t.id || (itemEl ? itemEl.getAttribute('data-item') : null);
        var newQty = parseInt(t.quantity, 10);

        if (newQty === 0) {
          handleInPlaceItemRemoval(itemEl, itemKey);
        } else {
          handleInPlaceQuantityUpdate(itemEl, itemKey, newQty);
        }
      };
    }

    document.querySelectorAll('cart-items').forEach(patchCartItemsInstance);

    var CartItemsClass = customElements.get('cart-items');
    if (CartItemsClass && CartItemsClass.prototype) {
      CartItemsClass.prototype.updateCart = function (t, e) {
        t = t || {};
        var itemEl = (t.id ? (this.cart || this).querySelector('[data-item="' + t.id + '"]') : null) || e;
        var itemKey = t.id || (itemEl ? itemEl.getAttribute('data-item') : null);
        var newQty = parseInt(t.quantity, 10);

        if (newQty === 0) {
          handleInPlaceItemRemoval(itemEl, itemKey);
        } else {
          handleInPlaceQuantityUpdate(itemEl, itemKey, newQty);
        }
      };
    }

    customElements.whenDefined('cart-items').then(function () {
      var cls = customElements.get('cart-items');
      if (cls && cls.prototype) {
        cls.prototype.updateCart = function (t, e) {
          t = t || {};
          var itemEl = (t.id ? (this.cart || this).querySelector('[data-item="' + t.id + '"]') : null) || e;
          var itemKey = t.id || (itemEl ? itemEl.getAttribute('data-item') : null);
          var newQty = parseInt(t.quantity, 10);

          if (newQty === 0) {
            handleInPlaceItemRemoval(itemEl, itemKey);
          } else {
            handleInPlaceQuantityUpdate(itemEl, itemKey, newQty);
          }
        };
      }
      document.querySelectorAll('cart-items').forEach(patchCartItemsInstance);
    });
    /* Cart Estimated Total breakdown toggle */
    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-cart-total-toggle]');
      if (!toggleBtn) return;

      e.preventDefault();
      var priceContainer = toggleBtn.closest('.cart__price-container') || document;
      var breakdown = priceContainer.querySelector('[data-cart-price-breakdown]');
      var caret = toggleBtn.querySelector('[data-cart-total-caret]');

      if (breakdown) {
        var isOpen = breakdown.classList.contains('is-open');
        if (!isOpen) {
          var targetH = breakdown.scrollHeight || 120;
          breakdown.style.maxHeight = targetH + 'px';
          breakdown.classList.add('is-open');
          toggleBtn.classList.add('is-active');
          toggleBtn.setAttribute('aria-expanded', 'true');

          setTimeout(function () {
            var drawerBody = toggleBtn.closest('.drawer__body') || document.querySelector('.drawer__body');
            if (drawerBody && typeof drawerBody.scrollTo === 'function') {
              drawerBody.scrollTo({
                top: drawerBody.scrollHeight,
                behavior: 'smooth'
              });
            }
          }, 100);
        } else {
          breakdown.style.maxHeight = '0px';
          breakdown.classList.remove('is-open');
          toggleBtn.classList.remove('is-active');
          toggleBtn.setAttribute('aria-expanded', 'false');
        }
      }
    });
    /* Product Page: Buy Now Direct Checkout Button Handler */
    document.addEventListener('click', function (e) {
      var buyNowBtn = e.target.closest('[data-buy-now-button]');
      if (!buyNowBtn) return;

      e.preventDefault();

      if (buyNowBtn.hasAttribute('disabled') || buyNowBtn.classList.contains('is-loading')) return;

      var form = buyNowBtn.closest('form') ||
                 (buyNowBtn.closest('cart-bar') ? buyNowBtn.closest('cart-bar').closest('product-info')?.querySelector('form[data-product-form]') : null) ||
                 document.querySelector('form[data-product-form]') ||
                 document.querySelector('form[action*="/cart/add"]');

      if (!form) {
        form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form[data-product-form]');
      }

      if (!form) {
        alert('Unable to process request. Please try adding to cart.');
        return;
      }

      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var variantInput = form.querySelector('[name="id"]') || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!variantInput || !variantInput.value) {
        alert('Please select a valid variant option.');
        return;
      }

      var variantId = variantInput.value;
      var qtyInput = form.querySelector('[name="quantity"]') || form.querySelector('input[name="updates[]"]');
      var quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      // Show loading state
      buyNowBtn.classList.add('is-loading');
      buyNowBtn.disabled = true;

      // Set checkout tracking flag for support popup and Buy Now cleanup
      try {
        sessionStorage.setItem('support_popup_went_to_checkout', 'true');
        sessionStorage.setItem('support_popup_checkout_timestamp', Date.now().toString());
        sessionStorage.setItem('buy_now_in_progress', 'true');
      } catch (err) {}

      var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart';
      var clearUrl = (window.theme && window.theme.routes && window.theme.routes.cart_clear_url) || '/cart/clear.js';
      var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
      if (!addUrl.endsWith('.js')) {
        addUrl = addUrl.replace(/\/$/, '') + '.js';
      }

      // Step 1: Save existing cart items so they can be restored if user returns from Buy Now
      fetch(cartUrl.replace(/\/$/, '') + '.js')
        .then(function (r) { return r.json(); })
        .then(function (currentCart) {
          try {
            if (currentCart && currentCart.items) {
              sessionStorage.setItem('buy_now_previous_cart', JSON.stringify(currentCart.items));
            }
          } catch (e) {}

          // Step 2: Clear cart so Buy Now checkout contains ONLY the currently selected product
          return fetch(clearUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });
        })
        .then(function () {
          // Step 3: Add the selected product and quantity to cart via clean JSON payload
          return fetch(addUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: quantity
            })
          });
        })
        .then(function (res) {
          if (!res.ok) {
            return res.text().then(function (text) {
              try {
                var errJson = JSON.parse(text);
                throw errJson;
              } catch (e) {
                throw new Error('Unable to add item to cart.');
              }
            });
          }
          return res.json();
        })
        .then(function () {
          // Step 4: Trigger checkout
          buyNowBtn.classList.remove('is-loading');
          buyNowBtn.disabled = false;

          var checkoutUrl = cartUrl.replace(/\/$/, '') + '/checkout';
          if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            checkoutUrl = window.Shopify.routes.root.replace(/\/$/, '') + '/checkout';
          }

          var cartForm = document.createElement('form');
          cartForm.action = cartUrl;
          cartForm.method = 'post';
          cartForm.style.display = 'none';

          var submitBtn = document.createElement('button');
          submitBtn.type = 'submit';
          submitBtn.name = 'checkout';
          cartForm.appendChild(submitBtn);

          document.body.appendChild(cartForm);
          submitBtn.click();

          // Fallback redirect if form submit does not navigate within 1.5 seconds
          setTimeout(function () {
            if (sessionStorage.getItem('buy_now_in_progress') === 'true' && !document.querySelector('iframe[src*="razorpay"], .razorpay-container')) {
              window.location.href = checkoutUrl;
            }
          }, 1500);
        })
        .catch(function (err) {
          console.error('Buy Now checkout error:', err);
          try { sessionStorage.removeItem('buy_now_in_progress'); } catch (e) {}
          buyNowBtn.classList.remove('is-loading');
          buyNowBtn.disabled = false;
          var errorHolder = form ? form.querySelector('[data-cart-error-message]') : null;
          var msg = err.description || err.message || 'Unable to proceed to checkout. Please try again.';
          if (errorHolder) {
            errorHolder.textContent = msg;
          } else {
            alert(msg);
          }
        });
    }, true);

    /* Helper to check if Buy Now or Razorpay checkout modal is active */
    window.isBuyNowOrCheckoutActive = function() {
      try {
        if (window.buyNowInProgress) return true;
        
        var checkVisibleFrames = function() {
          var frames = document.querySelectorAll('iframe[src*="razorpay"], .razorpay-container, #razorpay-checkout-frame, .rzp-checkout-frame');
          for (var i = 0; i < frames.length; i++) {
            var f = frames[i];
            if (f && (f.offsetWidth > 50 || f.offsetHeight > 50)) {
              var style = window.getComputedStyle(f);
              if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
                return true;
              }
            }
          }
          return false;
        };

        if (sessionStorage.getItem('buy_now_in_progress') === 'true') {
          if (checkVisibleFrames()) {
            return true;
          } else {
            sessionStorage.removeItem('buy_now_in_progress');
          }
        }
        if (checkVisibleFrames()) return true;
      } catch (e) {}
      return false;
    };

    window.addEventListener('message', function (event) {
      try {
        var data = event.data;
        var isCloseMsg = data && (
          data.name === 'magic_checkout_closed' ||
          data.action === 'close' ||
          (typeof data === 'string' && data.includes('close'))
        );
        if (isCloseMsg) {
          sessionStorage.removeItem('buy_now_in_progress');
          window.buyNowInProgress = false;
          unlockWebsiteScroll();
        }
      } catch (e) {}
    });

    /* Backup Safety Net: Buy Now Cart Cleanup on Returning to Store */
    function checkAndCleanupBuyNowCart() {
      try {
        var isBuyNowSession = sessionStorage.getItem('buy_now_in_progress');
        if (isBuyNowSession !== 'true' && !window.buyNowInProgress) {
          return;
        }
        var buyNowActive = isBuyNowSession || (window.buyNowInProgress ? 'true' : 'false');
        if (buyNowActive === 'true') {
          window.buyNowInProgress = true;
          var prevCartJson = sessionStorage.getItem('buy_now_previous_cart');
          sessionStorage.removeItem('buy_now_previous_cart');

          var prevItems = [];
          if (prevCartJson) {
            try { prevItems = JSON.parse(prevCartJson); } catch (e) {}
          }

          var clearUrl = (window.theme && window.theme.routes && window.theme.routes.cart_clear_url) || '/cart/clear.js';
          var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
          if (!addUrl.endsWith('.js')) {
            addUrl = addUrl.replace(/\/$/, '') + '.js';
          }

          // Force cart-drawer to stay closed during background restoration
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-open', 'is-closing');
            cartDrawer.cartDrawerIsOpen = false;
          }

          fetch(clearUrl, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })
            .then(function () {
              if (prevItems && prevItems.length > 0) {
                var itemsToAdd = prevItems.map(function (it) {
                  return {
                    id: it.id || it.variant_id,
                    quantity: it.quantity,
                    properties: it.properties || {}
                  };
                });
                return fetch(addUrl, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  },
                  body: JSON.stringify({ items: itemsToAdd })
                });
              }
            })
            .then(function () {
              var cartItems = document.querySelector('cart-items');
              if (cartItems && typeof cartItems.getCart === 'function') {
                cartItems.getCart();
              } else {
                var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart_url) ? window.theme.routes.cart_url : '/cart';
                fetch(cartUrl + '.js')
                  .then(function (r) { return r.json(); })
                  .then(function (cartData) {
                    document.querySelectorAll('[data-cart-count]').forEach(function (cnt) {
                      cnt.setAttribute('data-cart-count', cartData.item_count);
                      cnt.innerText = cartData.item_count;
                    });
                    document.dispatchEvent(new CustomEvent('theme:cart:change', {
                      bubbles: true,
                      detail: { cartCount: cartData.item_count }
                    }));
                  });
              }
            })
            .catch(function (err) {
              console.warn('Error cleaning up Buy Now cart:', err);
            })
            .finally(function () {
              var drawer = document.querySelector('cart-drawer');
              if (drawer) {
                drawer.classList.remove('is-open', 'is-closing');
                drawer.cartDrawerIsOpen = false;
              }
              setTimeout(function () {
                var hasRazorpayModal = document.querySelector('iframe[src*="razorpay"], .razorpay-container, #razorpay-checkout-frame, .rzp-checkout-frame');
                if (!hasRazorpayModal) {
                  sessionStorage.removeItem('buy_now_in_progress');
                  window.buyNowInProgress = false;
                  unlockWebsiteScroll();
                }
              }, 4000);
            });
        }
      } catch (err) {}
    }

    /* Scroll Unlocking Helper for Razorpay & Checkout Returns */
    function unlockWebsiteScroll() {
      try {
        if (window.isBuyNowOrCheckoutActive && window.isBuyNowOrCheckoutActive()) {
          return;
        }
        var supportModal = document.getElementById('UrbanSupportPopupModal');
        if (supportModal && supportModal.classList.contains('is-active')) {
          return;
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cartDrawer.classList.contains('is-open')) {
          return;
        }

        document.documentElement.removeAttribute('data-scroll-locked');
        if (document.body) {
          document.body.style.overflow = '';
          document.body.style.position = '';
          document.body.style.touchAction = '';
        }
        if (document.documentElement) {
          document.documentElement.style.overflow = '';
        }
        document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      } catch (e) {}
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        checkAndCleanupBuyNowCart();
        unlockWebsiteScroll();
      });
    } else {
      checkAndCleanupBuyNowCart();
      unlockWebsiteScroll();
    }

    window.addEventListener('pageshow', function() {
      checkAndCleanupBuyNowCart();
      unlockWebsiteScroll();
    });

    window.addEventListener('focus', function() {
      checkAndCleanupBuyNowCart();
      unlockWebsiteScroll();
    });

    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') {
        checkAndCleanupBuyNowCart();
        unlockWebsiteScroll();
      }
    });
  })();

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
